import { profileData } from "../data/profileData";

const Experience = () => (
	<section id="experience" className="section-card">
		<div className="section-header">
			<span>Experience</span>
			<h2>Professional experience</h2>
		</div>
		<div className="timeline">
			{profileData.experience.map((item, index) => {
				const isCurrent = item.range.toLowerCase().includes("present");
				return (
					<div key={`${item.title}-${item.company}`} className={`timeline-item ${isCurrent ? "is-current" : "is-past"}`}>
						<div className="timeline-track-segment">
							<div className="timeline-dot"></div>
							{index < profileData.experience.length - 1 && (
								<div className="timeline-line"></div>
							)}
						</div>
						
						<div className="timeline-content">
							<div className="timeline-meta">
								<div>
									<h3>{item.title}</h3>
									<p className="timeline-company">{item.company}</p>
									<p className="timeline-location">{item.location}</p>
								</div>
								<span className="timeline-range">{item.range}</span>
							</div>

							<div className="timeline-progress-container">
								<span className="progress-label">
									{isCurrent ? "Active Role — 5 mos" : "Completed — 4 mos"}
								</span>
								<div className="progress-bar-track">
									<div className={`progress-bar-fill ${isCurrent ? "active-fill" : "completed-fill"}`}></div>
								</div>
							</div>

							<ul>
								{item.bullets.map((line) => (
									<li key={line}>{line}</li>
								))}
							</ul>
						</div>
					</div>
				);
			})}
		</div>
	</section>
);

export default Experience;
